import { FC } from 'react';
import { Button } from 'atoms/Button';
import { Icon, IconType } from 'atoms/Icon';
import { Body } from 'atoms/Typography/Typography';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from './Mobile.module.css';

export const Mobile: FC<{ active: boolean; onClick: () => void }> = ({
  active,
  onClick,
}) => {
  const t = useTranslations();

  return (
    <Button className={styles.root} onClick={onClick}>
      <Body type="md" tag="span" className={styles.text}>
        {t('search.filter')}
      </Body>
      <Icon
        type={IconType[active ? 'close' : 'filter']}
        className={styles.icon}
      />
    </Button>
  );
};
